import { makeRunFromStartAction } from '../../common-actions/run-from-start.action';
import { LlmColumnModel } from '../llm-column.model';
import { LLMColumnSnapshotAction } from './llm-column-snapshot.action';

export class LlmRunFromStartAction extends makeRunFromStartAction(
  'Run From Start',
  LlmColumnModel,
  LLMColumnSnapshotAction
) {}
